export enum NextSpaceEventStatus {
  ACTIVE = 'ACTIVE',
  UPCOMING = 'UPCOMING'
}

export interface NextSpaceEventUser {
  id: string;
  name: string;
  email: string;
  profile_image: string;
}

export interface NextSpaceEvent {
  id: string;
  spaceId: string;
  spaceTitle: string;
  title: string;
  startTime: Date;
  endTime: Date;
  eventStartTimeOffsetMillis: number;
  hosts: NextSpaceEventUser[];
  participants: NextSpaceEventUser[];
}
